import React from 'react';
import logoIcon from './sandoog-logo-icon.png';   // 420×420 icon-only
import logoFull from './sandoog-logo.png';         // 410×563 full logo with wordmark
import { WHITE } from '../../../theme/brandColors';

interface SandoogLogoProps {
  size?: number;
  light?: boolean;
  withText?: boolean;
  vertical?: boolean;
  showCenter?: boolean;
}

const SandoogLogo: React.FC<SandoogLogoProps> = ({
  size = 36,
  light = false,
  withText = false,
  vertical = false,
  showCenter = true,
}) => {
  // Dark-background variant: square icon PNG + CSS-rendered wordmark (keeps navy text legible)
  if (withText && light) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: vertical ? 6 : 10,
          flexDirection: vertical ? 'column' : 'row',
        }}
      >
        <img
          src={logoIcon}
          alt='Sandoog'
          width={size}
          height={size}
          style={{ display: 'block', flex: 'none', objectFit: 'contain' }}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            lineHeight: 1.05,
            gap: 3,
            alignItems: vertical ? 'center' : 'flex-start',
          }}
        >
          <div
            style={{
              fontWeight: 800,
              fontSize: vertical ? 12 : 14,
              letterSpacing: '.12em',
              color: WHITE,
            }}
          >
            SANDOOG
          </div>
          {showCenter && (
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: '1px 7px',
                borderRadius: 4,
                background: 'var(--brand-green)',
                color: WHITE,
                fontSize: vertical ? 9 : 10,
                fontWeight: 700,
                letterSpacing: '.14em',
              }}
            >
              <span>CENTER</span>
              <span className='ar' style={{ fontSize: vertical ? 10 : 11, letterSpacing: 'normal' }}>صندوق</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Light-background variant: full logo PNG (icon + wordmark baked in)
  if (withText) {
    const w = Math.round(size * (410 / 563));
    return (
      <img
        src={logoFull}
        alt='Sandoog Center'
        width={w}
        height={size}
        style={{ display: 'block', objectFit: 'contain' }}
      />
    );
  }

  // Icon-only (most surfaces): square icon PNG
  return (
    <img
      src={logoIcon}
      alt='Sandoog'
      width={size}
      height={size}
      style={{
        display: 'block',
        flex: 'none',
        objectFit: 'contain',
      }}
    />
  );
};

export default SandoogLogo;
